import { Component, OnInit } from '@angular/core';
import { DataStorageService } from '../../../data-storage.service';
import { AvailableComponents } from '../../../side-bar/enumAvailableComponents';
import { MicrosoftTeamsPricing } from '../../../../models/MicrosoftTeamsPricing';
import { SecurityService } from '../../../security.service';
import { ApiTextService } from '../../../apiServices/text/text.service';
import { ApiService } from '../../../api.service';
import { PricingService } from '../../../pricing.service';

@Component({
  selector: 'app-operator-connect',
  templateUrl: './operator-connect.component.html',
  styleUrls: ['./operator-connect.component.scss']
})
export class OperatorConnectComponent implements OnInit {

  pricingList: MicrosoftTeamsPricing[];
  type: String;

  constructor(
    public dataStorageService: DataStorageService,
    public securityService: SecurityService,
    private tApi: ApiTextService,
    private api: ApiService,
    private pricing: PricingService) {

    pricing.getMsTeamsPriceList('operator-connect').then(data => {
      this.pricingList = data;
      this.type = this.getTypes();
      this.getValue().then((offer) => {
        const teams = this.dataStorageService.currentState.operatorConnect;
        teams.users = teams.users !== 0 ? teams.users : this.getUsersMin();
        this.updateMonthlyCosts();
      });
    });
  }
  ngOnInit() {
    const element = document.getElementById('msTeams-OperatorConnect');
    element.classList.add('active');
    this.dataStorageService.currentComponent = AvailableComponents['OperatorConnect'];
  }

  ngOnDestroy() {
    const element = document.getElementById('msTeams-OperatorConnect');
    element.classList.remove('active');
  }

  setValue(event, field: string, value) {
    const data = this.dataStorageService.currentState.operatorConnect;
    switch (field) {
      case 'users':
        data.users = value >= 2 ? value : 2;
        event.target.value = value >= 2 ? value : 2;
        break;
    }
    this.updateMonthlyCosts();
  }

  getTypes() {
    return Array.from(new Set(this.pricingList.map(x => x.type)))[0];
  }

  getUsersMin() {
    return Array.from(new Set(this.pricingList.map(x => x.usersMin)))[0];
  }

  getCostMonthly() {
    return Array.from(new Set(this.pricingList.map(x => x.costMonthly)))[0];
  }

  getCostUnique() {
    return Array.from(new Set(this.pricingList.map(x => x.costUnique)))[0];
  }

  getUsersAmount() {
    return this.dataStorageService.currentState.operatorConnect.users;
  }

  putValue() {
    return this.api.putMsTeams(this.dataStorageService.currentState.offerID, this.dataStorageService.currentState.operatorConnect, 'operator-connect');
  }

  getValue() {
    return this.api.getMsTeams(this.dataStorageService.currentState.offerID, 'operator-connect');
  }

  getTotalCosts() {
    return this.dataStorageService.currentState.operatorConnect.costMonthly + this.dataStorageService.currentState.operatorConnect.costUnique;
  }

  updateMonthlyCosts() {
    this.dataStorageService.currentState.operatorConnect.costUnique = this.getCostUnique();
    this.dataStorageService.currentState.operatorConnect.costMonthly = this.getCostMonthly() * this.dataStorageService.currentState.operatorConnect.users;
    this.putValue();
  }

  cancelClick() {
    this.dataStorageService.currentState.operatorConnect.users = this.getUsersMin();
    this.updateMonthlyCosts();
  }

  logData() {
    console.log(this.dataStorageService.currentState.operatorConnect);
    console.log(this.dataStorageService.teamsPricing);
  }

}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/operator-connect/operator-connect.component.ts